import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import Timer from './Timer'

export default class LoadHeaderUpdated extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMenu: false,
            showPlaneLoadNumOnly: null
        }
        this.thisRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
        let m = window.ENV?.showPlaneLoadNumOnly;
        this.setState({ showPlaneLoadNumOnly: m })
    }
    componentWillUnmount() {
        //alert('about to unmount:' + this.props.loadObj.plane + ": " + this.props.loadObj.planeLoadNum);
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                headerMenu: false
            });
        }
    }
    toggleHeaderMenu = () => {
        this.setState({ headerMenu: !this.state.headerMenu })
    }
    handleCancelLoad = loadId => {
        document.getElementById(loadId).click();
        this.hideHeaderMenu()
    };

    handleUpdateLoad = loadId => {
        document.getElementById(loadId).click();
        this.hideHeaderMenu()
    };
    hideHeaderMenu = () => {
        this.setState({ headerMenu: false })
    }
    returnHeaderClasses = () => {
        let { loadObj } = this.props;
        let { showPlaneLoadNumOnly } = this.state;
        let text = "load-header"
        if (loadObj.gearUp) {
            text += " geared-up";
        }
        if (showPlaneLoadNumOnly) {
            text += " show-plane-left"
        }
        return text;
    }


    renderPlanes = () => {
        let { loadObj } = this.props;
        let { showPlaneLoadNumOnly } = this.state;

        return <React.Fragment>
            <div className="second">
                <strong>{loadObj.plane.slice(0, 16).toUpperCase()}-{loadObj.planeLoadNum}</strong>
            </div>
            {!showPlaneLoadNumOnly ? <div className="third d-flex">
                <p className="small-skydiver"></p>
                <p className="loadcall-planes-p" >
                    {loadObj.totalJumpers}/ {loadObj.capacity}
                </p>
            </div>
                : null}
        </React.Fragment>
    }
    renderSlotRemaining = () => {
        let { loadObj } = this.props;
        return <div className="slots">
            <p>slots remaining</p>
        </div>
    }
    renderLoadNumber = () => {
        let { loadObj } = this.props;
        return <p className="load-no">
            {/* <EditableTimer
                            timeRemaining={loadObj.loadNum}
                            loadNum={loadObj.loadNum}
                            isPause={loadObj.isPaused}
                            type="loadNum"
                        /> */}
            {loadObj.loadNum}
        </p>
    }

    renderAltitude = (loadObj) => {
        return (
            <p className="timer">
                {loadObj.currentAltitude + " FT"}
            </p>
        )
    }

    render() {
        let { loadObj } = this.props;
        let { headerMenu, showPlaneLoadNumOnly } = this.state;
        var screenWidth = window.innerWidth

        const returnHeight = (screenWidth) => {
            let height
            if (screenWidth >= 1400) {
                height = 180
            }
            else if (screenWidth >= 992) {
                height = 120
            }
            else if (screenWidth >= 500) {
                height = 100
            }
            return height
        }

        const customStyle = {
            height: returnHeight(screenWidth)
        }
        { console.log(this.props.loadObj.planeColor, "hdfjhffddjh") }
        return (
            <div className={this.returnHeaderClasses(screenWidth)} style={customStyle}  >
                <div className="left-side" style={{ color: this.props.loadObj.planeColor || "green" }}>
                    {showPlaneLoadNumOnly ? this.renderPlanes() : this.renderLoadNumber()}
                </div>

                <div className={loadObj.gearUp ? "middle-side fe-pulse" : "middle-side"}>
                    <div className="time-remaining">
                        {loadObj.currentAltitude > 0 && loadObj.inAir ? this.renderAltitude(loadObj) : <Timer command={"start"} startTime={loadObj.timeRemaining} />}
                    </div>
                </div>

                <div className="right-side">
                    <div className="first">
                        {/* <p className="plane-img"></p> */}
                        <button onClick={this.toggleHeaderMenu}>
                            <i className="fa fa-ellipsis-v"></i>
                        </button>
                    </div>
                    <div className="load-left-count" >
                        {loadObj.capacity - loadObj.totalJumpers}
                    </div>
                    {showPlaneLoadNumOnly ? this.renderSlotRemaining() : this.renderPlanes()}

                </div>

            </div>

        )
    }
}
